import ASfCallingStatus from './index.vue';

ASfCallingStatus.install = app => {
  app.component(ASfCallingStatus.name, ASfCallingStatus);
};

export default ASfCallingStatus;
